import { PagePerformanceLifecycle } from '@/lib/page-performance/PagePerformanceLifecycle'

export class ChatPagePerformanceLifecycle extends PagePerformanceLifecycle {
  constructor(routeKey: string) {
    super(`chat:${routeKey}`, 'chat')
  }

  markVisible(): void {
    this.setVisible()
  }

  markInteractive(): void {
    this.setInteractive()
  }
}
